<template>
    <div class="container--large-content">

        <template v-if="user && cycle">
            <div
                v-if="user"
                class="container">
                <ul
                    class="buttons-list buttons-list--justify"
                    :class="{'buttons-list--row': !isXSmall}">
                    <!-- <li class="buttons-list__item">
                        <button
                            type="button"
                            @click="handleResetProfile"
                            class="button button--text page__go-back">
                            <span class="button__icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 768 768"
                                    :title="$t('previous')"><path d="M544 352H301.248l73.376-73.376c12.512-12.512 12.512-32.736 0-45.248s-32.736-12.512-45.248 0L178.752 384l150.624 150.624c6.24 6.24 14.432 9.376 22.624 9.376s16.384-3.136 22.624-9.376c12.512-12.512 12.512-32.736 0-45.248L301.248 416H544c17.664 0 32-14.336 32-32s-14.336-32-32-32z"/></svg>
                            </span>
                            <span class="button__label">{{ $t("change-profile") }}</span>
                        </button>
                    </li> -->
                </ul>
                <h1 class="page__title">{{ $t("discover-horoscope-of-x", {x: capitalize(user.fname)}) }}</h1>
                <ul class="sub-navigation">
                    <li class="sub-navigation__item">
                        <button
                            type="button"
                            @click="changePeriod('week')"
                            class="button--transparent sub-navigation__button"
                            :class="{'active': currentPeriod === 'week'}">
                            {{ $t("this-week") }}
                        </button>
                    </li>
                    <li class="sub-navigation__item">
                        <button
                            type="button"
                            @click="changePeriod('year')"
                            class="button--transparent sub-navigation__button"
                            :class="{'active': currentPeriod === 'year'}">
                            {{ $t("this-year") }}
                        </button>
                    </li>
                    <li class="sub-navigation__item">
                        <button
                            type="button"
                            @click="changePeriod('life')"
                            class="button--transparent sub-navigation__button"
                            :class="{'active': currentPeriod === 'life'}">
                            {{ $t("your-life") }}
                        </button>
                    </li>
                    
                </ul>
            </div>

            <template v-if="currentPeriod === 'week'">
                <div class="container">
                    <div
                        class="grid grid--centered">
                        <div class="grid__item desktop--6">
                            <dropdown
                                :trigger-title="$t('select-domains')"
                                :header-title="$t('domains')"
                            >
                                <span
                                    id="domainsListInstruction"
                                    class="sr-only">{{ $t("select-at-least-1-domain") }}</span>
                                <ul
                                    class="list--unstyled"
                                    v-if="activeDomains"
                                    aria-labelledBy="domainsListInstruction">
                                    <li
                                        v-for="(domain, index) in domains"
                                        :key="'domain-' + index">
                                        <div class="field--checkbox">
                                            <input
                                                type="checkbox"
                                                v-model="activeDomains"
                                                :checked="(activeDomains.indexOf(domain.name) !== -1) ? true : false"
                                                class="field--checkbox__input"
                                                :value="domain.name"
                                                :id="`field-domain-${domain.name}`">
                                            <label
                                                :for="`field-domain-${domain.name}`"
                                                class="field--checkbox__label">{{ domain.label }}</label>
                                        </div>
                                    </li>
                                </ul>
                            </dropdown>
                        </div>
                        <div class="grid__item desktop--6">
                            <ul
                                class="active-domains-list"
                                v-if="activeDomains">
                                <li
                                    class="active-domains-list__item"
                                    v-for="(domain, index) in activeDomains"
                                    :key="'domain-' + index">
                                    <div
                                        class="circle"
                                        :style="{backgroundColor: '#' + getDomainDetail(domain).color}" ></div>
                                    <span>{{ getDomainDetail(domain).label }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <h2 class="barometer-subtitle">{{ $t("tendance-of-the-week") }}</h2>
                    <p
                        class="page__subtitle"
                        v-html="$t('tendance-of-the-week-subtitle')"></p>
                </div>
                <div
                    class="linechart-wrapper"
                    :class="{'linechart-wrapper--empty' : activeDomains.length <= 0}">
                    <template v-if="activeDomains.length > 0">
                        <template v-if="domainsData.length > 0">
                            <LineChart
                                key="linechartKey"
                                :data="domainsData"
                                id="domains-chart" />
                        </template>
                    </template>
                    <template v-else>
                        <div class="container">
                            <div class="text-center">
                                <p>{{ $t("select-at-least-1-domain") }}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <div
                    v-if="userHoroscope"
                    class="container horoscope">
                    <h2>{{ $t("advices") }}</h2>

                    <div class="grid">
                        <div class="grid__item desktop--4">
                            <h3 class="horoscope__section-title">
                                <img
                                    :src="require('@/assets/images/artworks/horoscope/love.svg')"
                                    :alt="$t('love')" />
                            </h3>

                            <p
                                class="horoscope__content"
                                v-html="capitalize(userHoroscope.love)"></p>

                        </div>
                        <div class="grid__item desktop--4">
                            <h3 class="horoscope__section-title">
                                <img
                                    :src="require('@/assets/images/artworks/horoscope/work.svg')"
                                    :alt="$t('work')" />
                            </h3>

                            <p
                                class="horoscope__content"
                                v-html="capitalize(userHoroscope.work)"></p>
                        </div>
                        <div class="grid__item desktop--4">
                            <h3 class="horoscope__section-title">
                                <img
                                    :src="require('@/assets/images/artworks/horoscope/health.svg')"
                                    :alt="$t('finance')" />
                            </h3>

                            <p
                                class="horoscope__content"
                                v-html="capitalize(userHoroscope.finance)"></p>
                        </div>
                    </div>

                    <br />
                    <br />
                    <p>&#169; Serge Ducas {{ $dayjs().year() }}</p>

                </div>
            </template>
            
            <template v-if="currentPeriod === 'year'">
                <cycle-year
                    v-if="cycle"
                    :cycle="cycle"
                    :iday="iday"
                    :user="user"
                    :user-id="currentDataId"
                    :domain="currentYearDomain"
                    :max-iday="maxIday"
                    @previous-year="handlePreviousYear"
                    @next-year="handleNextYear"></cycle-year>
            </template>
            <template v-else-if="currentPeriod === 'life'">
                <cycle-life
                    v-if="cycle"
                    @year-clicked="displayYearDetail"
                    :cycle="cycle"></cycle-life>
            </template>
        </template>
        <template v-else>
            <div class="loader">
                <QuotesLoader />
            </div>
        </template>
    </div>
</template>

<script>
// @ is an alias to /src

import axios from "axios";

import { getMeCycle, getUserInfo} from "@/utils/api/usersApi.js";
import {SIGNS} from "@/utils/constants/zodiac.js";

import { userGroupInfo } from "@/utils/api/groupsApi.js";
import { getGroupTypeName, getGroupTypeColor } from "@/utils/helpers/group.js";
import { capitalize } from "@/utils/helpers/string.js";


import LineChart from "@/components/charts/LineChart.vue";
import Dropdown from "@/components/dropdown/Dropdown.vue";

import CycleYear from "@/views/pages/barometer/CycleYear.vue";
import CycleLife from "@/views/pages/barometer/CycleLife.vue";


import QuotesLoader from "@/components/loaders/QuotesLoader.vue";


import dayjs from "dayjs";
var dayOfYear = require("dayjs/plugin/dayOfYear");
dayjs.extend(dayOfYear);

export default {
    name: "Barometer",
    components: {
        "Dropdown": Dropdown,
        "QuotesLoader": QuotesLoader,
        "LineChart": LineChart,
        "CycleYear": CycleYear,
        "CycleLife": CycleLife,
    },
    data() {
        return {
            // Id of the user to see
            isXSmall: true,
            // user
            user: null,
            cycle: null,
            fetchCycleTentative: 0,
            currentPeriod: "life",
            defaultActiveDomains: ["love", "work", "fit"],
            activeDomains: [],
            domains: [{
                name: "fit",
                label: this.$t("fit-barometer"),
                color: "FAE087"
            }, {
                /*name: "siblings",
                label: this.$t("siblings-barometer"),
                color: "F5A682"
            }, {*/
                name: "family",
                label: this.$t("family-barometer"),
                color: "E37470"
            }, {
                name: "work",
                label: this.$t("work-barometer"),
                color: "E37470"
            }, {
                name: "love",
                label: this.$t("love-barometer"),
                color: "DF64B8"
            }, {
                name: "travel",
                label: this.$t("travel-barometer"),
                color: "7AE0D9"
            }, {
                name: "career",
                label: this.$t("career-barometer"),
                color: "7C98F5"
            }],
            iday: "",
            maxIday: 99,
            currentYearDomain: "",
        };
    },
    computed: {
        // currentDataId
        // Current data (user of group) id to display
        currentDataId() {
            return this.$store.getters["globalModule/getCurrentDataId"];
        },
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        // groups
        // User groups info
        groups() {
            return this.$store.getters["userModule/getGroups"];
        },
        horoscope() {
            return this.$store.getters["constantModule/getHoroscope"];
        },
        domainsData() {
            let data = [];

            if (this.activeDomains) {
                if (this.cycle) {
                    for (var i = this.activeDomains.length - 1; i >= 0; i--) {
                        const domain = this.getDomainData(this.activeDomains[i]);

                        if (domain) {
                            data.push(domain);
                        }
                    }
                }
            }

            return data;
        },
        userAstrologicalSign() {
            // if (this.cycle) {
            //     const sign = this.cycle.find(item => item.report_name === "signe").sign;
            //     return SIGNS[sign];
            // }
            return;
        },
        userHoroscope() {
            if (this.horoscope && this.userAstrologicalSign) {
                const signIndex = this.getObjetIndexByKey(this.horoscope, "sign", this.userAstrologicalSign);

                if (signIndex > -1) {
                    return this.horoscope[signIndex];
                }
            }
        },
        // groupBubbleData
        // Formated data t match what is expected by Bubblegraph component
        /*groupBubbleData() {
            if (this.groups) {

                const formatedGroups = this.groups.map((item) => {

                    const group = {
                        "traits": this.$t(getGroupTypeName(item.id_group_type)),
                        "color": getGroupTypeColor(item.id_group_type),
                        "id_person": item.id_person,
                        "type": "QQ",
                        "points_perc": 100 / this.groups.length,
                        "category": "group",
                    };

                    return group;
                });

                const formatedMembers = [];

                for (var i = this.groups.length - 1; i >= 0; i--) {
                    const members = this.getGroupMember(this.groups[i]);

                    for (var i2 = members.length - 1; i2 >= 0; i2--) {
                        const member = {
                            "traits": capitalize(members[i2].name),
                            "type": "Q",
                            "category": "group",
                            "color": getGroupTypeColor(this.groups[i].id_group_type),
                            "id": members[i2].id
                        };

                        formatedMembers.push(member);
                    }

                    // // Add user (current logged user) for each group
                    // formatedMembers.push({
                    //     "traits": capitalize(this.currentUser.fname),
                    //     "type": "Q",
                    //     "category": "group",
                    //     "color": getGroupTypeColor(this.groups[i].id_group_type),
                    //     "id": this.currentUser.id_person
                    // });
                }

                return formatedGroups.concat(formatedMembers);
            }


            return;
        }*/
    },
    watch: {
        currentDataId: {
            handler: function(val, oldVal) {
                if (val !== oldVal) {
                    this.cycle = null;
                    this.user = null;
                    this.fetchCycleTentative = 0;
                    if (val !== null) {
                        this.fetchUserInfo();
                        this.fetchCycle();
                    }
                }
            },
            immediate: true
        },
        iday(val) {
            if (val > this.maxIday) {
                this.iday = this.maxIday;
            }
        }
    },
    beforeMount: function() {
        this.activeDomains = this.defaultActiveDomains;
    },
    mounted: function() {
        this.$responsive.registerMediaQuery("from-small", () => {
            this.isXSmall = false;
        }, () => {
            this.isXSmall = true;
        });
        if (!this.horoscope) {
            this.fetchHoroscope();
        }

       

        // User Groups
        this.fetchGroups();
    },
    methods: {
        // // Fetch User Groups Info
        // fetchGroups() {
        //     const user = {
        //         "id": this.loggedUser.id_person
        //     };

        //     userGroupInfo(user).then((res) => {
        //         if (res.status === 200 && res.data) {
        //             if (res.data.message === "no group for user") {
        //                 this.$store.commit("userModule/setGroups", null);
        //                 return;
        //             } else {
        //                 this.$store.commit("userModule/setGroups", res.data);
        //             }
        //         }
        //     });
        // },
        // Fetch User Groups Info
        fetchGroups() {
            const user = {
                "id": this.loggedUser.id_person
            };

            userGroupInfo(user).then((res) => {
                if (res.status === 200 && res.data) {
                    let datasOptions = [];

                    datasOptions.push({
                        "value": this.loggedUser.id_person,
                        "label": this.$t("yourself") + ": " +this.loggedUser.fname
                    });

                    if (res.data.message === "no group for user") {
                        this.$store.commit("userModule/setGroups", null);
                    } else {
                        this.$store.commit("userModule/setGroups", res.data);
                        const groups = res.data;

                        groups.forEach((group) => {

                            const currentGroupUsers = this.getGroupMember(group);

                            if (currentGroupUsers) {

                                datasOptions.push({
                                    "value": group.id_group,
                                    "label": this.$t(getGroupTypeName(group.id_group_type)),
                                    "disabled": true
                                });

                                currentGroupUsers.forEach((user) => {
                                    datasOptions.push({
                                        "value": user.id,
                                        "label": this.capitalize(user.name)
                                    });
                                });
                            }

                        });

                    }

                    if (datasOptions.length > 0) {
                        this.$store.commit("globalModule/setAvailableDatas", datasOptions);
                    }
                }
            });
        },
        fetchCycle() {
            this.fetchCycleTentative += 1;

            const user = {
                "id": this.currentDataId
            };

            getMeCycle(user).then((res) => {
                if (res.status === 200 && res.data) {
                    this.cycle = res.data.part1;
                } else {
                    // If res.data is empty, it maybe bcause the API is still processing data (after a getMeCircleFirstTime call), try again to fetch data.
                    if (this.fetchCycleTentative <= 15 && (!res.data || (res.data && res.data.length === 0))) {
                        this.fetchCycle();
                    } else {
                        // Handle Error
                        let message = this.$t("a-server-error-occured-please-try-later");
                        this.currentDataId = null;
                        this.$notificationsBar.alert(message, {type: "warning"});
                    }
                }
            });
        },
        // Retrieve all data for a given domain in cycles
        getDomainData(domain) {
            if (domain) {
                return this.cycle.filter((item) => {
                    return item.report_name === "barometer" && item.domaine === domain;
                });
            }
        },
        // Retrieve the detail of a domain (label, color)
        getDomainDetail(domain) {
            if (domain) {
                const index = this.getObjetIndexByKey(this.domains, "name", domain);

                if (index > -1) {
                    return this.domains[index];
                }
            }
        },
        fetchHoroscope() {
            const currentLocal = this.$i18n.locale;

            axios({
                url: `/json/horoscope/horoscope.${currentLocal}.json`,
            }).then(res => {
                this.$store.commit("constantModule/setHoroscope", res.data);
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
        changePeriod(value) {
            if (value === "year") {
                const today = new Date();
                const userBirthdateDayNumber = dayjs(this.user.bdate).dayOfYear();
                const currentYearBirthDate = dayjs(today).dayOfYear(userBirthdateDayNumber).toDate();

                if (dayjs(today).isBefore(currentYearBirthDate)) {
                    this.currentYear = String(dayjs(currentYearBirthDate).year());
                    const userAge = this.user.bdate;
                    this.iday = today.getFullYear() - parseInt(this.user.bdate.substr(0, 4)) - 1;
                } else {
                    this.currentYear = String(dayjs(currentYearBirthDate).add(6, "month").year());
                    this.iday = today.getFullYear() - parseInt(this.user.bdate.substr(0, 4));
                }

            }

            this.currentPeriod = value;
        },
        displayYearDetail(iday, year, domain) {
            this.iday = iday;
            this.currentYear = year;
            this.currentYearDomain = domain;
            this.currentPeriod = "year";
        },
        handlePreviousYear() {
            let iday = this.iday;
            this.iday = iday -= 1;
        },
        handleNextYear() {
            let iday = this.iday;
            this.iday = iday += 1;
        },
        fetchUserInfo() {
            const user = {
                id: this.currentDataId
            };

            getUserInfo(user).then((res) => {
                if (res.status === 200 && res.data) {

                    this.user =  res.data;
                } else {
                    // Handle Error
                    let message = this.$t("a-server-error-occured-please-try-later");
                    this.$notificationsBar.alert(message, {type: "warning"});
                }
            });
        },
        handleResetProfile() {
            this.currentDataId = null;
            this.currentPeriod = "life";
        },
        seeLoggedUserProfile() {
            this.currentDataId = this.loggedUser.id_person;
            this.currentPeriod = "life";
        },
        getGroupMember(group) {
            let members = [];

            if (group && group.id_person_2) {

                const membersIdArray = group.id_person_2.split(",");
                const membersNameArray = group.name.split(",");

                for (var i = membersIdArray.length - 1; i >= 0; i--) {

                    const member = {
                        id: membersIdArray[i],
                        name: membersNameArray[i]
                    };

                    members.push(member);
                }
            }

            const sorteArray = members.sort(function(a, b) {
                var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                var nameB = b.name.toUpperCase(); // ignore upper and lowercase

                if (nameA < nameB) {
                    return -1; //nameA comes first
                }

                if (nameA > nameB) {
                    return 1; // nameB comes first
                }

                return 0;  // names must be equal
            });

            return sorteArray;
        },
    }
};
</script>

